import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const DeveloperProjectsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "DeveloperProjects",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M23.76 9.47c.07.17.11.38.13.59v.38c-.02.22-.07.42-.13.6l-.06.15c-.22.49-.61.88-1.07 1.1h-.01l-.15.07c-.17.07-.37.11-.58.13h-.38a2.7 2.7 0 0 1-.59-.13l-.15-.06c-.48-.23-.86-.62-1.08-1.09-.02-.07-.04-.12-.06-.17-.07-.17-.11-.38-.13-.59v-.38c.01-.14.03-.26.06-.38.02-.09.05-.16.07-.23s.04-.09.06-.14c.22-.49.6-.88 1.07-1.1h.01l.15-.07c.17-.07.37-.11.58-.13h.38c.21.02.41.07.59.13l.15.06c.48.23.86.62 1.08 1.09.02.07.04.12.06.17M30 3.73v24.53c0 .96-.78 1.73-1.73 1.73H3.73c-.96 0-1.73-.78-1.73-1.73V3.73C2 2.77 2.78 2 3.73 2h24.53c.96 0 1.73.78 1.73 1.73ZM5.56 10.5l3.52 3.52c.36.36.94.36 1.3 0l3.52-3.52c.36-.36.36-.94 0-1.3l-3.52-3.52a.917.917 0 0 0-1.3 0L5.56 9.2c-.36.36-.36.94 0 1.3m8.88 11.81c0-2.57-2.09-4.66-4.66-4.66s-4.66 2.09-4.66 4.66 2.09 4.66 4.66 4.66 4.66-2.09 4.66-4.66m11.59-3.21c0-.64-.52-1.17-1.17-1.17h-6.33c-.64 0-1.17.52-1.17 1.17v6.33c0 .64.52 1.17 1.17 1.17h6.33c.64 0 1.17-.52 1.17-1.17zm.43-9.02c0-.41-.33-.74-.72-.74h-.87c-.07-.27-.16-.5-.28-.72L25.2 8c.14-.13.22-.32.22-.53s-.08-.4-.22-.53l-.25-.27c-.13-.14-.32-.23-.52-.23s-.39.08-.52.23l-.62.62c-.2-.11-.42-.21-.66-.28h-.02v-.9c0-.41-.33-.74-.72-.74h-.36c-.4 0-.72.33-.72.74V7c-.27.07-.5.17-.72.29h.02l-.61-.63a.724.724 0 0 0-1.06 0l-.25.25c-.14.13-.22.32-.22.53s.08.4.22.53l.61.64c-.11.2-.2.43-.27.67v.02h-.87c-.4 0-.72.33-.72.74v.4c0 .41.32.74.72.74h.87c.07.26.16.48.27.69l-.61.62c-.14.13-.22.32-.22.53s.08.4.22.53l.26.27c.13.14.32.23.52.23s.39-.08.52-.23l.61-.62c.19.11.42.21.66.28h.02v.89c0 .41.33.74.72.74h.36c.4 0 .72-.33.72-.74v-.89c.27-.07.5-.17.72-.29h-.02l.61.63c.13.14.32.23.52.23s.39-.08.52-.23l.26-.27c.14-.13.22-.32.22-.53s-.08-.4-.22-.53l-.61-.63c.11-.2.2-.43.27-.67v-.02h.88c.4 0 .72-.33.72-.74v-.37Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M9.5 28C6.47 28 4 25.53 4 22.5S6.47 17 9.5 17s5.5 2.47 5.5 5.5S12.53 28 9.5 28m0-9C7.57 19 6 20.57 6 22.5S7.57 26 9.5 26s3.5-1.57 3.5-3.5S11.43 19 9.5 19M27 28h-9c-.55 0-1-.45-1-1v-9c0-.55.45-1 1-1h9c.55 0 1 .45 1 1v9c0 .55-.45 1-1 1m-8-2h7v-7h-7zM21.39 15H11c-.36 0-.69-.19-.87-.5a.99.99 0 0 1 0-1l5.2-9c.18-.31.51-.5.87-.5s.69.19.87.5l5.2 9c.18.31.18.69 0 1s-.51.5-.87.5Zm-8.66-2h6.93L16.2 7l-3.46 6Z"
      })
    })
  }));
};